import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { FileSearch } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SensitiveSectionConfirmDialog from '../components/SensitiveSectionConfirmDialog';

export default function MonitoraggioSicCtc() {
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(true);
  const message = useMemo(
    () =>
      'Stai per accedere alle Visure CTC. Questa sezione può mostrare informazioni sensibili (dati creditizi, segnalazioni e storico consultazioni).\n\nAssicurati di avere un motivo legittimo e l’autorizzazione necessaria, in conformità alla normativa privacy e alle policy aziendali.\n\nPer motivi di sicurezza, l’accesso a questa sezione può essere tracciato e registrato nei log di sistema.',
    []
  );

  const cancel = () => {
    setConfirmOpen(false);
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/', { replace: true });
  };

  const confirm = () => {
    setConfirmOpen(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <SensitiveSectionConfirmDialog
        open={confirmOpen}
        title="Conferma Accesso Dati Sensibili"
        message={message}
        onCancel={cancel}
        onConfirm={confirm}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#eef2ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FileSearch size={20} color="#4f46e5" />
          </Box>
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              CTC Consorzio Tutela Credito
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sezione predisposta per gestione interrogazioni CTC, esiti, documenti e monitoraggio.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Card
        sx={{
          p: 3,
          borderRadius: '16px',
          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.25 }}>
          Roadmap
        </Typography>
        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {[
            'Ricerca pratiche e soggetti (CF/P.IVA)',
            'Caricamento documenti e ricevute',
            'Stato richiesta e storico esiti',
            'Alert e scadenze di monitoraggio'
          ].map((text) => (
            <Box component="li" key={text} sx={{ mb: 0.75 }}>
              <Typography variant="body1">{text}</Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Pagina predisposta. In attesa delle specifiche funzionali.
        </Typography>
      </Card>
    </Box>
  );
}
